import Header from "./Header";
import ScriptingCard from "./ScriptingCard";
import ConnectAddressCard from "./ConnectAddressCard";
import OutputCard from "./OutputCard";
import { useState } from "react";


const MainPage = () => {
    const [address, setAddress] = useState("");
    const [result, setResult] = useState("");

    return (
        <>
            <div className="gradientBanner"></div>
            <div className="container">
                <Header />
                <ConnectAddressCard onValidAddressChange={setAddress} />
                <ScriptingCard disabled={address === ""} address={address} onResultReady={setResult} />
                <OutputCard disabled={result === ""} result={result} />
            </div>
        </>
    );
}

export default MainPage;